import { ContactFiatInstrumentFormKeys } from '../schemas/contactFiatInstrumentSchema'

export const CURRENCY_DETAILS_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'currency',
  'paymentMethods',
]

export const BASIC_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'entityType',
  'description',
  'businessName',
  'firstName',
  'lastName',
]

export const BENEFICIARY_ADDRESS_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'beneficiaryAddressLine1',
  'beneficiaryAddressLine2',
  'beneficiaryCity',
  'beneficiaryRegion',
  'beneficiaryPostCode',
  'beneficiaryCountryCode',
]

export const BASIC_BANK_ACCOUNT_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'accountNumber',
  'accountNumberConfirm',
  'bankCode',
  'routingNumber',
  'accountType',
]
export const BANK_ADDRESS_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'bankName',
  'bankCountryName',
  'bankAddressLine1',
  'bankAddressLine2',
  'bankCity',
  'bankRegion',
  'bankPostCode',
  'bankCountryCode',
]
export const INTERMEDIARY_BANK_FIELDS: ContactFiatInstrumentFormKeys[] = [
  'intermediaryBankCode',
  'intermediaryBankRoutingNumber',
  'intermediaryBankName',
  'intermediaryBankAddressLine1',
  'intermediaryBankAddressLine2',
  'intermediaryBankCity',
  'intermediaryBankRegion',
  'intermediaryBankPostCode',
  'intermediaryBankCountryCode',
]
